export function themedIcon(url: string, isDark: boolean = false) {
  if (!url) {
    return '';
  }
  // 如果是dark就在后缀名前加_dark，比如http://1/a.png -> https://1/a_dark.png
  if (isDark) {
    return url.replace(/\.(png|jpg|jpeg|gif|svg)$/, '_dark.$1');
  }
  return url;
}
